export default "__VITE_ASSET__Bh18d9BZ__"